import styled from 'styled-components'

export const HintContainer = styled.div`
	display: flex;
	height: min-content;
	justify-content: space-between;
	align-items: flex-end;
	margin-top: 4px;
	color: ${({ theme }) => theme.color.input.hint};
	flex-shrink: 0;
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: ${({ theme }) => theme.font.size.small};
`
